<template>
  <div class="search-inner">
    <span class="search-icon" @click="toggleSearch">
      <svg
        width="9px"
        height="9px"
        viewBox="0 0 9 9"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="0.5"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Icons/Search" stroke="#5C5C5C">
            <g id="Group" transform="translate(1.000000, 1.000000)">
              <circle id="Oval-2" cx="3" cy="3" r="3"></circle>
              <path
                d="M5.5,5.5 L7.5,7.5"
                id="Line"
                stroke-linecap="square"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </span>
    <transition name="slide-in">
      <div class="search-overlay" v-if="active">
        <div class="input-group">
          <form action="/search" method="get" class="search-form" role="search">
            <input
              type="search"
              name="q"
              id="search"
              value=""
              placeholder="search"
              ref="inputfield"
            />
          </form>
          <span @click="active = !active"
            ><svg
              width="18px"
              height="19px"
              viewBox="0 0 18 19"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Search"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                stroke-linecap="square"
              >
                <g
                  id="klassik-joined-search-step1"
                  transform="translate(-1257.000000, -59.000000)"
                  fill-rule="nonzero"
                  stroke="#1F2D3D"
                >
                  <g
                    id="UI/CloseX"
                    transform="translate(1252.000000, 55.000000)"
                  >
                    <path
                      d="M5,4.82142857 L22.9737948,22.1757317 L5,4.82142857 Z"
                      id="Line-4"
                    ></path>
                    <path
                      d="M23.0005493,4.82142857 L5,22.174996 L23.0005493,4.82142857 Z"
                      id="Line-4"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggleSearch() {
      this.active = !this.active;
      if (this.active) {
        this.$nextTick(() => {
          this.$refs.inputfield.focus();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-inner {
  .search-icon {
    cursor: pointer;

    svg {
      width: 17px;
      height: 17px;
    }
  }
  .search-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 10;

    .input-group {
      background-color: #ffffff;
      padding: 50px 36px;
      display: flex;
      justify-content: space-between;
      max-width: 1440px;
      margin: 0 auto;

      @include res(tab-p) {
        padding: 30px 20px;
      }

      .search-form {
        width: 80%;

        input {
          color: $medium-grey;
          font-size: 24px;
          line-height: 29px;
          text-align: left;
          border: none;
          font-family: $font-text;
          width: 100%;

          &:focus,
          &:active {
            outline: none;
          }

          &::placeholder {
            color: $medium-grey;
          }
        }
      }
      span {
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }
  }
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: opacity 0.5s;
}
.slide-in-enter,
.slide-in-leave-to {
  opacity: 0;
}
</style>
